import {HStack, IconButton, Spinner} from "@chakra-ui/react";
import {useState} from "react";
import {FiSend} from "react-icons/fi";
import {InputProps} from "../../models";
import {FormInput} from "../UI";

type Props = InputProps<string> & {
    onSent: VoidFunction
    loading: boolean
    failed: boolean
};

function SendMessageInput(p: Props) {
    const [exceed, setExceed] = useState(false);
    return <HStack
        mt={3}
        bg="gray.100"
        p={2}
        alignItems={exceed ? "flex-end" : "center"}
    >
        <FormInput
            type="textarea"
            data={{
                currentValue: p.currentValue,
                flex: "2 1 auto",
                onUpdate: p.onUpdate,
                onKeyDown: function (e) {
                    if (e.code === "Enter" && !e.shiftKey) {
                        e.preventDefault();
                        p.onSent();
                    }
                },
                onSizeExceed: setExceed,
                placeholder: p.placeholder
            }}
        />
        <IconButton
            icon={p.loading ? <Spinner/> : <FiSend size={16} color="white"/>}
            borderRadius="full"
            aria-label="Send"
            onClick={p.onSent}
            disabled={p.loading}
            bgColor={p.failed ? "red.500" : "primary.500"}
        />
    </HStack>;
}

export default SendMessageInput;
